var _ellipse, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 7.58332,
    rx: 6.41667,
    ry: 6.41667,
    fill: "#FA422E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73124 20.2741C4.72986 17.7246 7.32546 16.3333 10.0636 16.3333H17.9364C20.6745 16.3333 23.2701 17.7246 24.2688 20.2741C24.8989 21.8828 25.4763 23.8341 25.628 25.8343C25.6698 26.385 25.219 26.8333 24.6667 26.8333H3.33334C2.78105 26.8333 2.33021 26.385 2.37197 25.8343C2.52367 23.8341 3.10114 21.8828 3.73124 20.2741Z",
    fill: "#FA422E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0853 3.62355H11.0854C11.4736 3.62355 12.25 3.84865 12.25 4.74904C12.25 5.64943 10.6972 6.62483 9.92083 6.99999C9.53264 6.99999 8.52339 6.77483 7.59166 5.8745C5.66826 4.0159 6.42709 0.247089 7.59166 1.37261C9.92072 3.62355 10.309 3.62355 11.0853 3.62355Z",
    fill: "#FA422E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9147 3.62355H16.9146C16.5264 3.62355 15.75 3.84865 15.75 4.74904C15.75 5.64943 17.3028 6.62483 18.0792 6.99999C18.4674 6.99999 19.4766 6.77483 20.4083 5.8745C22.3317 4.0159 21.5729 0.247089 20.4083 1.37261C18.0793 3.62355 17.691 3.62355 16.9147 3.62355Z",
    fill: "#FA422E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.800b6601ac6c8b2a4c684f4c1df55204.svg";
export { ForwardRef as ReactComponent };